const env = window.__env || {};

const config = {
  env: env.env ?? 'localhost',
  baseUrl: env.baseUrl ?? 'http://localhost:8080/api',
  s3BaseUrl: env.s3BaseUrl ?? 'https://s3.wasabibeta.com',
  ssoDomain: env.ssoDomain ?? 'https://sso-beta.cloudstoragecdn.com',
  ssoAudience: env.ssoAudience ?? 'https://sso-beta.cloudstoragecdn.com',
  ssoClientId: env.ssoClientId ?? 'cP2KtQl5rnM9ESE1aE5SpM2Kj5Z0PwYb',
  ssoRedirectUrl: env.ssoRedirectUrl ?? '/login',
  reportErrors: env.reportErrors ?? true,
  buildVersion: env.buildVersion ?? 'localhost',
  reportErrorsDebug: env.reportErrorsDebug ?? true,
  buildEnv: env.buildEnv ?? '',
  dsn: env.dsn ?? '',
  appId: env.appId ?? '',
  appPrefix: env.appPrefix ?? '',
  vaultCustomDomainsEnabled: env.vaultCustomDomainsEnabled ?? false
};

export default config;
